import axios from "axios";
import iziToast from "izitoast";
import store from '../store'

axios.defaults.baseURL = process.env.VUE_APP_URL_API;

axios.interceptors.request.use((config)=> {
    
    if(store.getters.getToken){
        if(config.url.search("api/Token")!==1){
            config.headers.Authorization=store.getters.getToken;
        }
    }
    try {
        if(config.data){
            config.data.dt19=process.env.VUE_APP_API_KEY;
            config.data.idTrack=store.getters.getAplicacion;
        } else {
            config.data={
                
                dt19:process.env.VUE_APP_API_KEY,
                idTrack:store.getters.getAplicacion.id
            };
            console.log("config.dataasdasdas", store.getters)
        }
    } catch (e) {
    }
    return config;
});

axios.interceptors.response.use(
    response => response,
    respuestaErro
);

function respuestaErro(error){
    try {
        if(error.config.params.showMessage == null || error.config.params.showMessage == true){
            if(error.response.data){
                if (error.response.data.dt1)
                    iziToast.show({theme: 'light',position: "bottomRight", message:error.response.data.dt1});
                if (error.response.data.Message)
                    iziToast.show({theme: 'light',position: "bottomRight", message:error.response.data.Message});
            }
        }
        
    } catch (e) {
        iziToast.error({theme: 'light',position: "bottomRight", message:String(error)});
    }
    return Promise.reject(error);
}

axios.interceptors.response.use(response => response, async error => {
    const status = error.response ? error.response.status : null;
    if (status === 401) {
        const original = error.config;
        original._retry = true;
        store.commit('setTrue');
        if(store.getters.getEstado===false){
            await store.dispatch('regenerar');
            store.commit('setFalse');
        }
        original.headers.Authorization = store.getters.getToken;
        return axios.request(original);
    } else {
        return Promise.reject(error);
    }
});



